"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var eval_scope_filter_html_1 = __importDefault(require("@components/filters/custom-filters/eval-scope-filter.html"));
(function (module) {
    module.factory('prEvalScopeFilterDirectiveLinker', [
        '$timeout',
        function ($timeout) {
            var operatorTranslations = {
                subject: 'FSFILTERS.EVALUATIONS_SUBJECT',
                other: 'FSFILTERS.EVALUATIONS_OTHER'
            };
            var Linker = function ($rootScope_, $fcFilter_, $scope_) {
                var _this = this;
                this.$rootScope = $rootScope_;
                this.$fcFilter = $fcFilter_;
                this.$scope = $scope_;
                this.$scope.template = function () {
                    return eval_scope_filter_html_1.default;
                };
                $timeout(function () {
                    // timeout is needed to wait for the template scope to be defined
                    _this.$templateScope = _this.$scope.$$childHead;
                    angular.extend(_this.$templateScope, {
                        updateFilter: _this.updateFilter.bind(_this),
                        operator: _this.$scope.displayedFilter.filter.operator,
                        operatorLabel: operatorTranslations[_this.$scope.displayedFilter.filter.operator]
                    });
                    _this.$scope.$watch('type', _this.setupOperators.bind(_this));
                });
            };
            Linker.prototype.setupOperators = function () {
                var _this = this;
                this.$scope.operatorMenu = _.map(operatorTranslations, function (translateKey, value) {
                    return {
                        value: value,
                        label: _this.$fcFilter('fcTranslate')(translateKey),
                    };
                });
            };
            Linker.prototype.updateFilter = function () {
                var _this = this;
                this.$templateScope.operatorLabel = operatorTranslations[this.$templateScope.operator];
                $timeout(function () {
                    _this.$scope.displayedFilter.filter.operator = _this.$templateScope.operator;
                    _this.$scope.displayedFilter.filter.operand = true;
                    _this.$rootScope.$broadcast('filterChanged');
                });
            };
            return Linker;
        }
    ]);
})(angular.module('qualtrics.pr'));
